<template>
  <AbstractTaskModalComponent v-bind="$attrs" :task="action" :event="event">
    <slot />
  </AbstractTaskModalComponent>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import AbstractTaskModalComponent from "./AbstractTaskModalComponent.vue";
import type { EditTaskType } from "../helper/DefaultTask";
import type { EventListEventFieldsFragment } from "@/graphql";
import type { EventEditType } from "../../event/modal/EventEditType";

defineProps({
  action: {
    type: Object as PropType<EditTaskType>,
    required: true,
  },
  event: {
    type: Object as PropType<EventListEventFieldsFragment | EventEditType>,
    required: true,
  },
});
</script>

<style lang="scss" scoped></style>
